module.exports = __webpack_public_path__ + "img/iconcourse.ebab534a.svg";